export default __webpack_public_path__ + "static/media/roth401K.36521170.svg";